import React from 'react';

// Ab dieser Strecke in Pixeln gilt eine Berührung als Wischen und nicht mehr
// als Tippen. Darunter liegt sie im Bereich dessen, was beim Antippen ohnehin
// an Bewegung entsteht.
const MIN_WISCH = 50;

// Liefert 1 fürs Weiterblättern, -1 fürs Zurück und 0, wenn die Bewegung kein
// Wischen war. Die senkrechte Strecke muss kleiner sein als die waagrechte,
// sonst wäre jedes Scrollen ein Blättern.
export function wischRichtung(dx, dy, mindest = MIN_WISCH) {
  if (Math.abs(dx) < mindest || Math.abs(dx) <= Math.abs(dy)) {
    return 0;
  }
  return dx < 0 ? 1 : -1;
}

// Blättert zyklisch — wie die Pfeile über den Kategorien.
export function naechsterIndex(index, schritt, anzahl) {
  if (anzahl < 1) {
    return 0;
  }
  return (index + schritt + anzahl) % anzahl;
}

// Grossansicht eines Bildes. Ein Klick irgendwohin schliesst sie wieder, die
// Escape-Taste ebenso — ohne das waere sie mit der Tastatur nicht zu verlassen.
// Wischen blaettert durch die Bilder der aktuellen Ansicht, die Pfeiltasten
// ebenfalls.
class Lightbox extends React.Component {
  constructor(props) {
    super(props);
    this.aufTaste = this.aufTaste.bind(this);
    this.beginn = null;
    // Nach einem Wischen folgt auf das Beruehren noch ein Klick. Ohne diese
    // Merkung schlösse sich die Ansicht sofort nach dem Blättern wieder.
    this.gewischt = false;
  }

  componentDidMount() {
    document.addEventListener('keydown', this.aufTaste);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.aufTaste);
  }

  aufTaste(event) {
    if (event.key === 'Escape') {
      this.props.onClose();
      return;
    }
    if (event.key === 'ArrowLeft') {
      this.blaettern(-1);
    }
    if (event.key === 'ArrowRight') {
      this.blaettern(1);
    }
  }

  blaettern(schritt) {
    const anzahl = this.props.bilder.length;
    if (anzahl < 2) {
      return;
    }
    this.props.onIndex(naechsterIndex(this.props.index, schritt, anzahl));
  }

  aufBeruehrungStart(event) {
    const punkt = event.changedTouches[0];
    this.beginn = { x: punkt.clientX, y: punkt.clientY };
    this.gewischt = false;
  }

  aufBeruehrungEnde(event) {
    if (!this.beginn) {
      return;
    }
    const punkt = event.changedTouches[0];
    const richtung = wischRichtung(punkt.clientX - this.beginn.x, punkt.clientY - this.beginn.y);
    this.beginn = null;
    if (richtung !== 0) {
      this.gewischt = true;
      this.blaettern(richtung);
    }
  }

  aufKlick() {
    if (this.gewischt) {
      this.gewischt = false;
      return;
    }
    this.props.onClose();
  }

  render() {
    const bild = this.props.bilder[this.props.index];
    if (!bild) {
      return null;
    }
    return (
      <div
        className="lightbox"
        role="dialog"
        aria-modal="true"
        aria-label="Bild in Grossansicht"
        onClick={() => this.aufKlick()}
        onTouchStart={(event) => this.aufBeruehrungStart(event)}
        onTouchEnd={(event) => this.aufBeruehrungEnde(event)}
      >
        <img src={bild.src} alt={bild.alt || ''} className="lightbox-image" />
        {this.props.bilder.length > 1 && (
          <span className="lightbox-zaehler">
            {this.props.index + 1} / {this.props.bilder.length}
          </span>
        )}
      </div>
    );
  }
}

export default Lightbox;
